import React from "react";
import "./SubMenuBar.css";
import { Link } from "react-scroll";


const OFFSET = -160;

const items = [
  { to: "Overview", label: "Overview" },
  { to: "WhyiAssetMax", label: "Why iAssetMax™" },
  { to: "Benefits", label: "Benefits" },
  { to: "Features", label: "Features" },
  { to: "UseCase", label: "Use cases" },
];

const SubMenuBar = () => {
  return (
    <div className="SubMenuBar sticky top-[100px] z-40 w-full bg-white shadow-md">
      <nav className="mx-auto flex w-full max-w-[90rem] px-5 sm:px-14">
        <ul className="flex w-full justify-between gap-[1%] border-b-4 sm:gap-[3%]">
          {items.map(({ to, label }) => (
            <li key={to}>
              <Link activeClass="active" offset={OFFSET} smooth spy to={to}>
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default SubMenuBar;